import React from 'react';
import { Badge, Tooltip } from 'antd';
import { ChecklistOutlined, FieldTimeOutlined } from '@ant-design/icons';

const StatusIndicators = ({ status }) => {
  const checklistCount = status.checklists?.length || 0;
  const amoFieldsCount = status.fields_ids?.length || 0;
  
  if (checklistCount === 0 && amoFieldsCount === 0) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
      {checklistCount > 0 && (
        <Tooltip title={`Чеклистов: ${checklistCount}`}>
          <Badge 
            count={checklistCount} 
            size="small"
            style={{ 
              backgroundColor: '#1890ff',
              fontSize: '9px',
              height: '14px',
              minWidth: '14px',
              lineHeight: '14px'
            }}
          />
        </Tooltip>
      )}
      {amoFieldsCount > 0 && (
        <Tooltip title={`AMO полей: ${amoFieldsCount}`}>
          <Badge 
            count={amoFieldsCount} 
            size="small"
            style={{ 
              backgroundColor: '#52c41a',
              fontSize: '9px',
              height: '14px',
              minWidth: '14px',
              lineHeight: '14px'
            }}
          />
        </Tooltip>
      )}
    </div>
  );
};

export default StatusIndicators; 